import React, { useState } from "react";

import themeCheck from "../../assets/images/screen_icons/theme-check.svg";

const ThemeSelect = (props: any) => {
  const { themeList, Theme, setTheme, config, onUpdate, actionEnd } = props;

  const changeTheme = (name: string) => {
    setTheme(name);
    onUpdate({ id: config.id, theme: name });
    actionEnd(true);
  };

  return (
    <React.Fragment>
      <div className="mt-5 mb-4"><label htmlFor="youtube" className="crs-subtitle"> 色彩主題 </label></div>
      <div>
        <div className="theme-box">
          {(themeList || []).map((item: any, index: number) => {
            if (config.type === "WIDGET_MIND_MAP" && item.name === "theme3") {
              return null;
            }
            return (
              <div className={`theme-item ${item.name === Theme? "themeThis" : ""}`} key={index} onClick={() => changeTheme(item.name)}>
                <div className="theme-content">
                  <div className={`theme-style ${item.name}`}>
                    <div className="themeBar lg"></div>
                    <div className="themeBar lg">
                      <div className="themeBar md"></div>
                      <div className="themeBar sm"></div>
                    </div>
                  </div>
                </div>
                <div className="theme-block"></div>
              </div>
            );
          })}
        </div>
      </div>
    </React.Fragment>
  );
};

export default ThemeSelect;